import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center"
          style={{ background: 'var(--bg-primary)' }}
        >
          <div className="text-center max-w-md px-6">
            <div className="text-5xl mb-6">⚠️</div>
            <h1
              className="text-2xl font-bold mb-3"
              style={{ color: 'var(--text-primary)' }}
            >
              Something went wrong
            </h1>
            <p
              className="text-sm mb-6"
              style={{ color: 'var(--text-tertiary)' }}
            >
              We hit an unexpected error. Please refresh the page or contact us
              if the problem persists.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="btn-primary"
            >
              <span>Refresh Page</span>
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
